import { connect } from 'react-redux';

import ScheduledPosts from './ScheduledPosts';
import { fetchScheduledPosts } from '../../../../../core/actions/classRoom/scheduledPosts';
import {
  classRoomName,
  currentClassRoomId,
  getScheduledPosts,
  scheduledPostCount,
  isFetchingScheduledPosts,
  hasFetchedAllScheduledPosts,
} from '../../../../../core/selectors/classroom';

const mapStateToProps = (state) => ({
  count: scheduledPostCount(state),
  spaceId: currentClassRoomId(state),
  scheduledPosts: getScheduledPosts(state),
  currentSpaceName: classRoomName(state),
  isFetching: isFetchingScheduledPosts(state),
  hasFetchedAll: hasFetchedAllScheduledPosts(state),
});

const mapDispatchToProps = (dispatch) => ({
  fetch: (spaceId) => dispatch(fetchScheduledPosts(spaceId)),
});

const ScheduledPostsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ScheduledPosts);

export default ScheduledPostsContainer;
